<template>
  <div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true">
    </loading>
	
    <v-row class="text-left search-bar">
      <v-col class="pt-4 pl-0 col-9 col-md-8">
        <v-tabs class="ml-6 tabsLeft" color="#215DA7" v-model="tab">
          <v-tabs-slider color="#215DA7" style="left:0"></v-tabs-slider>
          <v-tab><span style="font-size:15pt; font-weight:550">場次資訊</span></v-tab>
          <v-tab><span style="font-size:15pt; font-weight:550">報名及成績一覽表</span> </v-tab>
        </v-tabs>
      </v-col>
    </v-row>
    
    <div v-show="tab==0" id="router" :style="viewStyle">
      <div id="box" class="pa-5" style="margin-top:3%">
        <v-row class="pb-5">
          <v-icon class="ma-0 pa-0" size="30" style="color:#215DA7">mdi-menu-right</v-icon>
          <h4 class="DarkBlue pt-1">場次資訊</h4>
        </v-row>
        <v-row class="mx-2">
          <v-col class="pa-0 col-12 col-md-6">
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>場次代碼</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.examNo"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>考試方式</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-select class="text_field" dense readonly background-color="#F4F8F9" outlined style="-webkit-text-fill-color: #000"
                :items="examMethodList" item-text="title" item-value="valuev" v-model="datasets.exportStatus">
                  <template v-slot:append>
                    <v-icon></v-icon>
                  </template>
                </v-select>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>認證日期</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="examDate"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>繳費方式</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="payGroup"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>場次報名狀況</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
              <v-select class="text_field" dense readonly background-color="#F4F8F9" outlined style="-webkit-text-fill-color: #000"
              :items="applyStatusList" item-text="title" item-value="valuev" v-model="datasets.applyStatus">
                <template v-slot:append>
                  <v-icon></v-icon>
                </template>
              </v-select>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="pa-0 col-12 col-md-6">
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>認證考場</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="companyInfo"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>認證項目</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.class1"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>認證模組</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.class2"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>認證廠商</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.class3"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>已報名人數</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.numOfApplicants"></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        
        <v-row class="mx-2">
          <v-row class="ma-0">
            <v-col class="col-2">
              <div class="text-right pt-2 pt14"><span class="start">*</span>是否有外籍考生</div>
            </v-col>
            <v-col class="py-0 pt-2 pl-6">
              <v-row class="ma-0">
                <v-radio-group class="ma-0 pa-0" dense readonly v-model="datasets.examBranch">
                  <v-row>
                    <v-radio class="pr-2" value="1" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">是</span>
                      </template>
                    </v-radio>
                    <v-radio class="pr-2" value="0" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">否</span>
                      </template>
                    </v-radio>
                  </v-row>
                </v-radio-group>
                <v-row v-if="datasets.examBranch=='1'" class="my-0 ml-4 pa-0">
                  <v-checkbox v-for="(data, index) in examLimitList" :key = "index" :value = "data.valuev" readonly class="pr-3 pa-0 ma-0" color="#215DA7" v-model="datasets.examLimit">
                    <template v-slot:label>
                      <span class="pt14" style="color:#000000">{{data.title}}</span>
                    </template>
                  </v-checkbox>
                </v-row>
              </v-row>
            </v-col>
          </v-row>
        </v-row>
      </div>
      <v-row class="ma-0" justify="center" style="min-height:100px">
        <v-btn class="ma-1" outlined style="width:240px; color:#FFFFFF; background:#215DA7; border:none; border-radius:8px;" @click="getDatasetExcel()">
          下載場次資訊（含成績）
        </v-btn>
        <v-btn v-if="datasets.certificatePrintCount=='2'" class="ma-1" outlined style="width:240px; color:#FFFFFF; background:#215DA7; border:none; border-radius:8px;" @click="getCertificatePdf()">
          下載場次證書
        </v-btn>
      </v-row>
    </div>

    <div v-show="tab==1" id="router" :style="viewStyle">
      <v-simple-table id="tablebox" fixed-header height="670px" class="pa-3" style="margin: 3% 5.8% 4% 4%">
        <template v-slot:default>
          <thead>
            <tr>
              <th @click="sort('name')" class="text-left">報考人 <v-icon small>icon-form_sort_off</v-icon></th>
              <th @click="sort('examMemberType')" class="text-left">報考身份 <v-icon small>icon-form_sort_off</v-icon></th>
              <th @click="sort('havePay')" class="text-left">報考費用 <v-icon small>icon-form_sort_off</v-icon></th>
              <th @click="sort('examScore')" class="text-left">成績 <v-icon small>icon-form_sort_off</v-icon></th>
              <th @click="sort('payStatus')" class="text-left">繳費狀態 <v-icon small>icon-form_sort_off</v-icon></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data,index) in examRegList" :key="index">
              <td style="min-width: 110px"><h4>{{data.name}}</h4></td>
              <td style="min-width: 120px"><h4>{{$Global.getTypevDescription(memberTypeList,data.examMemberType)}}</h4></td>
              <td style="min-width: 120px"><h4>{{data.havePay}}</h4></td>
              <td style="min-width: 100px"><h4>{{data.examScore}}</h4></td>
              <td style="min-width: 160px"><h4 :style = "[{'color' : (data.payStatus=='3') ? '#000' : (data.payStatus=='4') ? '#000' : '#F00'}]">{{$Global.getTypevDescription(payStatusList,data.payStatus)}}</h4></td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>

    <ShowMsg ref="ShowMsg" :onSave="onShowMsg"/>
    <LoadingVideo ref="LoadingVideo"/>
    <ShowConfirm ref="ShowConfirm" :onSave="onShowConfirm"/>
    <DeleteConfirm ref="DeleteConfirm" :onSave="deleteExamRegBatch"/>
    <ProjectPassword ref="ProjectPassword" />
  </div>
</template>

<script>
// import QrcodeVue from 'qrcode.vue'
import ShowMsg from '@/dialogs/ShowMsg'
import LoadingVideo from '@/dialogs/LoadingVideo'
import ShowConfirm from '@/dialogs/ShowConfirm'
import DeleteConfirm from '@/dialogs/DeleteConfirm'
import ProjectPassword from '@/dialogs/ProjectPassword'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.min.css';

export default {
  name: 'ProjectManagement',
  components: {ShowMsg, LoadingVideo, ShowConfirm, DeleteConfirm, ProjectPassword, Loading},
  mounted(){
    this.tab = ((this.$route.query.tab == '1') ? 1 : (this.$route.query.tab == '2') ? 2 : (this.$route.query.tab == '3') ? 3 : 0)
    if(this.tab == 3){
      this.isLoading = true;
    }
    this.$Global.getFrontendAreaList().then(res=>{ this.frontendAreaList = res })
    this.$Global.getExamMethodList().then(res=>{ this.examMethodList = res })
    this.$Global.getApplyItemList().then(res=>{ this.applyItemList = res })
    this.$Global.getApplyStatusList().then(res=>{ this.applyStatusList = res })
    this.$Global.getPayStatusList().then(res=>{ this.payStatusList = res })
    this.$Global.getMemberTypeList().then(res=>{ this.memberTypeList = res })
    this.$Global.getHiTrustStoreList().then(res=>{ this.hiTrustStoreList = res })
    this.$Global.getHiTrustServiceListProject().then(res=>{ this.hiTrustServiceList = res })
    this.$Global.getExamLimitList().then(res=>{ this.examLimitList = res })
    this.getDataset()
  },
  data:() => ({
    paymentMethod:['信用卡繳款','ATM、銀行郵局臨櫃繳款','LINE Pay','銀聯卡'],
    payment:'',
    expectPaymentMethod:'',
    mOrderNumber:'',
    mOrderFee:0,
    datasets: [],
    examRegList: [],
    examRegPayList: [],
    viewStyle:{},
    orderBy:'id',
    direction:'desc',
    tab:0,
    mouseInfor:0,
    isLoading: false,

    list: [],
    statusCheckbox:'',
    examRegSelectAll: false,
    examRegSelectList: [],
    examRegPaySelectAll: false,
    examRegPaySelectList: [],
    certificateDeliveryList: [],
    receiptDownload: false,
    receiptAppendDownload: false,
    frontendAreaList: [],
    examMethodList: [],
    applyItemList: [],
    applyStatusList: [],
    payStatusList: [],
    memberTypeList: [],
    hiTrustStoreList: [],
    hiTrustServiceList: [],
    examLimitList: [],

    companyInfo:'', //合併company + examClassroom
    payGroup:'', //轉換
    examDate:'', //合併examDate + examTime
    examTimeNow:false, //true可以申請紙本證書 false還沒考試
    deadline:'', //合併deadlineDate + deadlineTime
    e17Date:'', //deadlineDate
    deadlineNow:false, //false不能繳費 + true可以繳費
    deleteId:'', // -1: all
    totalPayApply:'',
    browserName:'',
    platform:'',
  }),
  created(){
    this.calculateWindows()
    this.$root.$on('windowInnerHeight',()=>{
      this.calculateWindows()
    })
  },
  watch:{
    "examRegSelectAll":function(){
      for (var i=0; i<this.examRegSelectList.length; i++) {
        if(this.examRegList[i].selectDisable == false){
          this.examRegSelectList[i] = this.examRegSelectAll
          this.$set(this.examRegSelectList, i, this.examRegSelectAll) //trigger
        }
      }
    },
    "examRegPaySelectAll":function(){
      for (var i=0; i<this.examRegPaySelectList.length; i++) {
        this.examRegPaySelectList[i] = this.examRegPaySelectAll
        this.$set(this.examRegPaySelectList, i, this.examRegPaySelectAll) //trigger
      }
    },
    "tab":function(){
      this.orderBy = 'id'
      this.direction = 'desc'
      this.getExamRegList()
      this.examRegSelectAll = false
      this.examRegPaySelectAll = false
      for (var i=0; i<this.examRegSelectList.length; i++) {
        this.examRegSelectList[i] = false
      }
      for (var i=0; i<this.examRegPaySelectList.length; i++) {
        this.examRegPaySelectList[i] = false
      }
    },
    "totalPay":function(){
      this.mOrderFee = this.expectPaymentMethod.includes('1') ? parseInt(this.totalPay) : (parseInt(this.totalPay+'00'))
    },
    "totalPayApply":function(){
      console.log('totalPayApply')
      this.mOrderFee = this.expectPaymentMethod.includes('1') ? parseInt(this.totalPayApply) : (parseInt(this.totalPayApply+'00'))
    }
  },
  computed: {
    totalCount(){
      let res = 0
      for (var i=0; i<this.examRegPaySelectList.length; i++) {
        if(this.examRegPaySelectList[i]){
          res++
        }
      }
      return res
    },
    totalPay(){
      let res = 0
      for (var i=0; i<this.examRegPaySelectList.length; i++) {
        if(this.examRegPaySelectList[i]){
          res += Number(this.examRegPayList[i].havePay)
        }
      }
      return res
    },
  },
  methods:{
    calculateWindows(){
      this.viewStyle = {height: window.innerHeight-128 + 'px'}
    },
    redirectPath(path, deliverId){
      this.$router.push({path: path, query: {
        id: this.$route.query.id,
        tab: this.tab,
        data: this.$Global.encrypt(JSON.stringify({
          class1: this.datasets.class1,
          class2: this.datasets.class2,
          class3: this.datasets.class3,
          examName: this.datasets.examName,
          examNo: this.datasets.examNo,
          gradeStatus: this.datasets.gradeStatus,
          idCard: this.datasets.idCard,
          name: this.datasets.name,
          receiptTitle: this.datasets.groupReceiptTitle,
          sameRcvCert: this.datasets.sameRcvCert,
          rcvCertName: this.datasets.rcvCertName,
          rcvCertCtel: this.datasets.rcvCertCtel,
          receiverCountry: this.datasets.receiverCountry,
          receiverArea: this.datasets.receiverArea,
          receiverAddress: this.datasets.receiverAddress,
        })),
        deliverId: this.$Global.encrypt(JSON.stringify(deliverId)),
      }})
    },
    redirectPath2(path, deliverId){
      this.$router.push({path: path, query: {
        id: this.$route.query.id,
        tab: this.tab,
        deliverId: this.$Global.encrypt(JSON.stringify(deliverId)),
      }})
    },
    browserVersion() {
      var UA = navigator.userAgent;
      var tMatch;
      var M = UA.match(/(OPERA|CHROME|SAFARI|FIREFOX|MSIE|TRIDENT(?=\/))\/?\s*(\d+)/i) || [];
      if (/TRIDENT/i.test(M[1])) {
        tMatch = /\brv[ :]+(\d+)/g.exec(UA) || [];
        return "IE " + (tMatch[1] || "");
      }
      if (M[1] === "Chrome") {
        tMatch = UA.match(/\b(OPR|Edg)\/(\d+)/);
        if (tMatch != null) {
          return tMatch.slice(1).join(" ").replace("OPR", "Opera").replace("Edg", "Edge");
        }
      }
      M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
      if ((tMatch = UA.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tMatch[1]);
      return M.join(" ");
    },
    confirmOrder(state){
      this.browserName = this.browserVersion()
      this.platform = navigator.platform
      let tmp = this.browserName + ' ' + this.platform

      this.$Global.setSystemLog(
        '4', //ipAddress
        sessionStorage.getItem('cerpsMemberIdCard'), //userId
        'payTime', //type
        this.datasets.examNo, //examNo
        '繳費監測', //logContent
        new Date(), //note1
        new Date(this.datasets.deadlineDate + 'T' + this.datasets.deadlineTime), //note2
        tmp, //note3
      )

      if(!this.deadlineNow){
        this.$refs.ShowMsg.open(0,'繳費期限逾期','請聯繫學會人員。')
        this.$Global.setSystemLog(
          '', //ipAddress
          sessionStorage.getItem('cerpsMemberIdCard'), //userId
          'deadlineNow', //type
          this.datasets.examNo, //examNo
          '繳費期限逾期', //logContent
          new Date(), //note1
          new Date(this.datasets.deadlineDate + 'T' + this.datasets.deadlineTime), //note2
          tmp, //note3
        )
        return
      }
      if(!this.payment || this.payment==''){
        this.$refs.ShowMsg.open(0,'請輸入所有必填','請選擇繳費方式 !')
        return
      }
      //未開通繳費方式
      if(this.payment=='2' || this.payment=='3'){
        this.$refs.ShowMsg.open(0,'繳費方式尚未開啟','請選擇「信用卡繳款」或「ATM、銀行郵局臨櫃繳款」繳費方式，「LINE Pay」及「銀聯卡」繳費方式尚未開啟，感謝您的配合 !')
        this.payment=''
        return
      }
      //
      if(state != 'payType'){
        if((this.datasets.paymentNo || this.datasets.payType=='1') && this.payment=='1'){
          this.$refs.ShowMsg.open(0,'您已產生繳費帳號','請至信箱收信或聯繫學會人員取得繳費帳號，謝謝。')
          return
        }
      }
      if(this.datasets.payType && this.payment != this.datasets.payType){
        this.$refs.ShowConfirm.open(0,'調整繳費方式','您原本選擇' + ((this.datasets.payType=='0') ? '信用卡繳款': (this.datasets.payType=='1') ? 'ATM、銀行郵局臨櫃繳款' : (this.datasets.payType=='2') ? 'LINE Pay': (this.datasets.payType=='3') ? '銀聯卡': '') + '為繳費方式，本次將繳費方式改為' + 
        ((this.payment=='0') ? '信用卡繳款': (this.payment=='1') ? 'ATM、銀行郵局臨櫃繳款' : (this.payment=='2') ? 'LINE Pay': (this.payment=='3') ? '銀聯卡': '') + '。系統將調整您設定的繳費方式，以便進行繳費。', true)
        return
      }
      if(this.totalPay == 0){
        this.$refs.ShowMsg.open(0,'請選擇繳費對象','請點選複選框(checkbox)選擇將要繳費的對象 !')
        return
      }
      if(!this.datasets.payType || this.payment == this.datasets.payType){
        this.setDataset('order')
      }
    },
    createOrder() {
      var self = this
      self.isLoading = true;
      self.expectPaymentMethod = self.payment
      var midString = ''
      /*
      console.log('self.examRegPaySelectList')
      console.log(self.examRegPaySelectList)
      
      console.log('self.examRegList')
      console.log(self.examRegList)
      
      console.log('self.examRegSelectList')
      console.log(self.examRegSelectList)
      
      console.log('self.examRegPayList')
      console.log(self.examRegPayList)
      */
      for (var i=0; i<self.examRegPaySelectList.length; i++){
        self.examRegPayList[i].paymentNo = (self.examRegPayList[i].paymentNo == null || self.examRegPayList[i].paymentNo == '') ? null : self.examRegPayList[i].paymentNo
        if(self.examRegPaySelectList[i] == true) {
          self.examRegPayList[i].isSelected = true
          midString = midString + self.examRegPayList[i].idCard + ','
        }
      }
      //console.log(self.examRegList)
      
      var orderData = {
        'examNo': self.datasets.examNo,
        'orderType': '1',
        'payWay': self.expectPaymentMethod,
        'mid': midString.substring(0,midString.length-1),
        'membersDetail': JSON.stringify(self.examRegPayList),
        'fee': self.totalPay,
        'category': 'REG',
        'havePay': '1',
        'group': '1'
      }
      
      //console.log(orderData)
      
      var request = {
        method: 'POST',
        url: '/erpOrder',
        data: this.Qs.stringify(orderData)
      }
      this.$http(request).then(function(response) {
        console.log(response);
        self.mOrderNumber = response.data.data;
      }).catch((error)=>{
        console.log(error);
      }).finally(()=>{
        setTimeout(() => {
          self.isLoading = false
        },5000)
        if (self.mOrderNumber.includes('hitrust')) {
          parent.window.location.replace(self.mOrderNumber);
        } else {
          self.startWI();
        }
      })
    },
    createApplyOrder(mApplyCode, mTotalPay, mPaymentMethod, idCard) {
      var self = this
      self.isLoading = true;
      self.expectPaymentMethod = mPaymentMethod
      // self.mOrderFee = self.expectPaymentMethod.includes('1') ? mTotalPay : (mTotalPay + '00')
      self.mOrderFee = mTotalPay
      self.totalPayApply = mTotalPay
      
      // var orderData = {
      //   'examNo': self.datasets.examNo,
      //   'note': mApplyCode,
      //   'orderType': '1',
      //   'payWay': self.expectPaymentMethod,
      //   'mid': sessionStorage.getItem('cerpsMemberIdCard'),
      //   'membersDetail': '',
      //   'fee': self.expectPaymentMethod.includes('1') ? mTotalPay : (mTotalPay + '00'),
      //   'category': 'APPLY',
      //   'havePay': '1'
      // }
      var orderData = {
        'examNo': self.datasets.examNo, // self.datasets.examNo  mApplyCode
        'note': mApplyCode,
        'orderType': '1',
        'payWay': self.expectPaymentMethod,
        'mid': idCard,
        // 'mid': sessionStorage.getItem('cerpsMemberIdCard'),
        'membersDetail': '',
        'fee': mTotalPay,
        'category': 'APPLY',
        'havePay': '1'
      }

      //console.log(orderData)
      
      var request = {
        method: 'POST',
        url: '/erpOrder',
        data: this.Qs.stringify(orderData)
      }
      this.$http(request).then(function(response) {
        console.log(response);
        self.mOrderNumber = response.data.data;
        self.mOrderFee = self.expectPaymentMethod.includes('1') ? (parseInt(self.totalPayApply+'00')) : (parseInt(self.totalPayApply+'00'))
      }).catch((error)=>{
        console.log(error);
      }).finally(()=>{
        setTimeout(() => {
          self.isLoading = false
        },5000)
        // self.mOrderFee = self.expectPaymentMethod.includes('1') ? parseInt(self.totalPayApply) : (parseInt(self.totalPayApply+'00'))
        //self.mOrderFee = self.expectPaymentMethod.includes('1') ? parseInt(self.totalPayApply) : (parseInt(self.totalPayApply+'00'))
        if (self.mOrderNumber.includes('hitrust')) {
          parent.window.location.replace(self.mOrderNumber);
        } else {
          self.startWI();
        }
      })
    },
    startWI() {
      this.$refs.submit.click();
      /*
      var self = this
      var postData = {
        'Type': 'Auth',
        'storeid': '50934',
        'ordernumber': self.mOrderNumber,
        'amount': self.datasets.examFee,
        'orderdesc': '認證鑑定費用',
        'depositflag': '1',
        'queryflag': '1',
        'pan':'',
        'expiry':'',
        'e01':'',
        'returnURL': 'https://13.114.173.137/Apply/#/registerInformationList',
        'merUpdateURL': 'http://13.114.173.137:8086/common/wiCcRecord'
      }
      var request = {
        method: 'POST',
        url: '/TrustLink/TrxReqForJava',
        data: this.Qs.stringify(postData)
      }
      this.$http(request).then(function(response) {
        console.log(response)
      }).catch(()=>{
      })
      */
    },
    getDataset(){
      var self = this
      var request = {
        method: 'GET',
        url: '/erpExam/' + JSON.parse(this.$Global.decrypt(this.$route.query.id)),
        params: {},
      }
      this.$http(request).then(function(response) {
        self.datasets = response.data.data
      }).catch(()=>{
        console.log('系統錯誤: '+'請聯繫系統管理人員，編號為pjt-7956')
      }).finally(()=>{
        self.getExamRegList()
        self.getCertificateDeliveryList()
        this.payGroup = (self.datasets.payGroup=='1') ? '團體繳費': (self.datasets.payGroup=='2') ? '個人繳費': ''
        if(self.datasets.exportStatus =='4'){
          this.companyInfo = self.datasets.company
        }else{
          this.companyInfo = self.datasets.company + '-' + self.datasets.examClassroom
        }
        this.examDate = self.datasets.examDate + ' ' + self.datasets.examTime
        this.deadline = self.datasets.deadlineDate + ' ' + self.datasets.deadlineTime
        this.payment = (self.datasets.payType) ? self.datasets.payType : ''

        let time = this.datasets.examTime.split('-')
        this.examTimeNow = (new Date() > new Date(this.datasets.examDate + 'T' +  time[0])) ? true : false
        // console.log('[A]this.deadline: ' + this.deadline)
        this.deadlineNow = (new Date() < new Date(self.datasets.deadlineDate + 'T' + self.datasets.deadlineTime)) ? true : false
        // console.log('[A]this.deadlineNow: ' + this.deadlineNow)
        if(this.datasets.examLimit){
          this.datasets.examLimit = JSON.parse(this.datasets.examLimit)
        }
      })
    },
    setDataset(order){
      if(order=='order' || order=='payType'){
        if(this.payment=='1' && (!this.datasets.paymentNo || this.datasets.paymentNo=='')){
          this.datasets.paymentNo = '請至信箱收信或聯繫學會人員取得繳費帳號'
        }
        this.datasets.payType = this.payment
      }

      var self = this
      var request = {
        method: 'PUT',
        url: '/erpExam',
        data: this.Qs.stringify(self.datasets),
      }
      this.$http(request).then(function(response) {
        console.log(response)
      }).catch(()=>{
        console.log('系統錯誤: '+'請聯繫系統管理人員，編號為pjt-7957')
      }).finally(()=>{
        if(order=='payType'){
          self.confirmOrder('payType')
        }
        if(order=='count'){
          self.getDataset()
        }
        if(order=='order'){
          self.isLoading = true;
          self.createOrder()
        }
        // self.getDataset()
      })
    },
    sort(field){
      this.orderBy = field
      this.direction = (this.direction == 'desc') ? 'asc' : 'desc'
      switch(this.tab){
        case 1:
        case 2:
          this.getExamRegList()
          break
        case 3:
          this.getCertificateDeliveryList()
          break
        default:
          break
      }
    },
    getExamRegList(){
      var self = this
      var request = {
        method: 'GET',
        url: '/erpExamRegListByExamNo',
        params: {
          'limit': 1000,
          'order': self.orderBy,
          'direction': self.direction,
          'examNo': self.datasets.examNo,
          'source': 'superteacher',
          'company': sessionStorage.getItem('cerpsCompany'),
        },
      }
      this.$http(request).then(function(response) {
        self.examRegList = response.data.data.data
        for (var i=0; i<self.examRegList.length; i++) {
          if(self.examRegList[i].payStatus=='3' || self.examRegList[i].payStatus=='4'){
            self.$set(self.examRegList[i], 'selectDisable', true)
          }else{
            self.$set(self.examRegList[i], 'selectDisable', false)
          }
        }
      }).catch(()=>{
        console.log('系統錯誤: '+'請聯繫系統管理人員，編號為pjt-7958')
      }).finally(()=>{
        self.examRegSelectList = []
        for (var i=0; i<self.examRegList.length; i++) {
          self.examRegSelectList.push(false)
        }

        let tmp = self.examRegList
        self.examRegPayList = []
        for(var i=0; i<tmp.length; i++) {
          // console.log('[tmp[i].payStatus]: ' +  tmp[i].payStatus)
          // console.log('[tmp[i].payStatus] typeof: ' + typeof(tmp[i].payStatus))
          if(tmp[i].payStatus!='2' && tmp[i].payStatus!='3' && tmp[i].payStatus!='4' && tmp[i].payStatus!='7')
          self.examRegPayList.push(tmp[i])
        }
        if(self.datasets.payGroup=='1'){ //團體繳費才做
          self.examRegPaySelectList = []
          for (var i=0; i<self.examRegPayList.length; i++) {
            self.examRegPaySelectList.push(true)
          }
        }
        for (var i=0; i<self.examRegList.length; i++) {
          if(self.examRegList[i].payStatus == '4'){
            self.receiptDownload = true
            return
          }
        }
      })
    },
    getCertificateDeliveryList(){
      var self = this
      var request = {
        method: 'GET',
        url: '/certificateDeliveryListByApplicantIdCardAndExamNo',
        params: {
          'examNo': self.datasets.examNo,
          'applicantIdCard': sessionStorage.getItem('cerpsMemberIdCard'),
          'limit':1000,
          'order': self.orderBy,
          'direction': self.direction,
        },
      }
      this.$http(request).then(function(response) {
        self.certificateDeliveryList = response.data.data
      }).catch(()=>{
        console.log('系統錯誤: '+'請聯繫系統管理人員，編號為pjt-7959')
      }).finally(()=>{
        for (var i=0; i<self.certificateDeliveryList.length; i++) {
          if(self.certificateDeliveryList[i].paymentStatus == '1'){
            self.receiptAppendDownload = true
            return
          }

          if(self.certificateDeliveryList[i].paymentMethod == '1' && self.certificateDeliveryList[i].paymentNo == '請至信箱收信或聯繫學會人員取得繳費帳號'){
            const promise = JSON.parse(self.certificateDeliveryList[i].orderId)
            for(var j=0; j<promise.length; j++){
              if(promise[j].payWay == '1'){
                self.getCertificateOrdernumber(i,self.certificateDeliveryList[i].paymentMethod,promise[j].orderId)
              }
            }
          }
        }
        self.isLoading = false
      })
    },
    async getCertificateOrdernumber(index,payType,orderId){
      let storeid = this.hiTrustStoreList[payType].storeid
      var self = this
      var request = {
        method: 'POST',
        url: '/TrustLink/QueryOnly?ordernumber=' + orderId + '&storeid=' + storeid + '&type=7' + '&examNo=' + this.datasets.examNo + '&idCard=' + this.datasets.idCard,
        params: {}
      }
      await this.$http(request).then(function(response) {
        if(response.data.data.e21){
          self.certificateDeliveryList[index].paymentNo = response.data.data.e21
        }else{
          self.certificateDeliveryList[index].paymentNo = ''
        }
      }).catch(()=>{
        self.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為Mod-7967')
      }).finally(()=>{
      })
    },
    setCertificateDelivery(index){
      if(this.certificateDeliveryList[index].paymentMethod=='1' && !this.certificateDeliveryList[index].paymentNo){
        this.certificateDeliveryList[index].paymentNo = '請至信箱收信或聯繫學會人員取得繳費帳號'
      }
      var self = this
      var request = {
        method: 'PUT',
        url: '/certificateDeliveryPaymentNoAndPayTypeUpdate',
        data: this.Qs.stringify(self.certificateDeliveryList[index])
      }
      this.$http(request).then(function(response) {
        console.log(response)
      }).catch(()=>{
        self.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為pjt-7960')
      }).finally(()=>{
        self.createApplyOrder(self.certificateDeliveryList[index].applyCode, self.certificateDeliveryList[index].applyFee, self.certificateDeliveryList[index].paymentMethod, self.certificateDeliveryList[index].idCard)
      })
    },
    deleteExamReg(id){
      var self = this
      var request = {
        method: 'PUT',
        url: '/erpExamRegStatusUpdate/' + id,
        params: {},
      }
      this.$http(request).then(function(response) {
        // console.log(response)
        self.$Global.setSystemLog(
          '', //ipAddress
          sessionStorage.getItem('cerpsMemberIdCard'), //userId
          'deleteExamRegStatusUpdate', //type
          self.datasets.examNo, //examNo
          id, //logContent
          '', //note1
        )
      }).catch(()=>{
        console.log('系統錯誤: '+'請聯繫系統管理人員，編號為pjt-7961')
      }).finally(()=>{
        self.getExamRegList()
        self.$refs.ShowMsg.open(0,'已刪除資料','您已刪除資料 !')
      })
    },
    deleteExamRegBatch(){
      if(this.deleteId != -1){
        this.deleteExamReg(this.deleteId)
      } else { //all
        for(var i=0; i<this.examRegSelectList.length; i++){
          if(this.examRegSelectList[i]){
            let id = this.examRegList[i].id
            console.log("[deleteExamRegBatch] id: " + id)
            this.deleteExamReg(id)
          }
        }
      }
    },
    getReceiptPdf(){
      var self = this
      self.isLoading = true
      var request = {
        method: 'GET',
        url: '/receiptDownloadMerge/exportpdf',
        params: {
          'examNo': self.datasets.examNo,
          'printType': 'member',
        },
        responseType: 'arraybuffer'
      }
      this.$http(request).then(function(response) {
        var blob = new Blob([response.data], { type: 'application/rar' });
        // IE專用方法
        //window.navigator.msSaveBlob(blob, 'erpComeMoPage.pdf'); 
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = (self.datasets.examNo + '_考生收據.rar')
        link.click()
      }).catch((error)=>{
        alert(error)
      }).finally(function() {
        self.isLoading = false
      });
    },
    getReceiptAppendPdf(){
      var self = this
      self.isLoading = true
      var request = {
        method: 'GET',
        url: '/receiptAppendDownloadMerge/exportpdf',
        params: {
          'examNo': self.datasets.examNo,
          'printType': 'member',
        },
        responseType: 'arraybuffer'
      }
      this.$http(request).then(function(response) {
        var blob = new Blob([response.data], { type: 'application/rar' });
        // IE專用方法
        //window.navigator.msSaveBlob(blob, 'erpComeMoPage.pdf'); 
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = (self.datasets.examNo + '_證書申請收據.rar')
        link.click()
      }).catch(()=>{
        self.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為pjt-7962')
      }).finally(function() {
        self.isLoading = false
      });
    },
    getCertificatePdf(){
      var self = this
      self.$refs.LoadingVideo.open()
      var request = {
        method: 'GET',
        url: '/certificateDownloadMerge/exportpdf',
        params: {
          'examNo': this.datasets.examNo,
          'printType': 'member',
          'company': sessionStorage.getItem('cerpsCompany'),
        },
        responseType: 'arraybuffer'
      }
      this.$http(request).then(function(response) {
        var blob = new Blob([response.data], { type: 'application/rar' });
        // IE專用方法
        //window.navigator.msSaveBlob(blob, 'erpComeMoPage.pdf'); 
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = (self.datasets.examNo + '_考生證書.rar')
        link.click()
      }).catch((error)=>{
        alert(error)
      }).finally(function() {
        self.$refs.LoadingVideo.close()
      });
    },
    getDatasetExcel(){
      var self = this
      var request = {
        method: 'GET',
        url: '/erpExamRegPageExcel',
        params: {
          'examNo': this.datasets.examNo,
          // 'keyword':self.keyword != ''? self.keyword: null, //manufacturer
          'company': sessionStorage.getItem('cerpsCompany'),
        },
        responseType: 'arraybuffer'
      }
      this.$http(request).then(function(response) {
        var blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
        // IE專用方法
        //window.navigator.msSaveBlob(blob, 'export.xls'); 
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = (self.datasets.examNo + '_場次成績.xls')
        link.click()
      }).catch((error)=>{
        alert(error)
      }).finally(function() {
        self.$Global.setSystemLog(
          '', //ipAddress
          sessionStorage.getItem('cerpsMemberIdCard'), //userId
          'erpExamRegPageExcel', //type
          self.datasets.examNo, //examNo
          '下載場次成績-管理', //logContent
          '', //note1
          '', //note2
          '', //note3
        )
      });
    },
    duplication(){      
      this.$router.push({path: '/projectApplication', query: {
        setCopy: this.$route.query.id,
      }})
      this.$root.$emit('menuName', '認證考試');
      this.$root.$emit('subMenuName', '專案認證申請')
    },
    onShowMsg(){
      this.redirectPath('/projectList')
    },
    onShowConfirm(){
      this.setDataset('payType')
    },
  }
}
</script>

<style>
  @media (max-width: 959px) {
    .menuApp {
      display: unset !important;
    }
    .menuWeb, .menuAppBtn {
      display: none !important;
    }
    .appBtn{
      display: unset !important;
    }
    .webBtn{
      display: none !important;
    }
  }
</style>